import React, { useEffect, useState } from 'react';
import { HEADING } from '../../../components/heading/constants/constants';
import Heading from '../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import Icons from '../../../components/icons/Icons';
import styles from "./GetCompanyInfo.styles";
import commonStyles from "../OnboardingStepsCommonStyles";
import FooterWImageAndActionButtons from '../../../components/footerwimageandactionbuttons/FooterWImageAndActionButtons';
import { COMPANY_NAME_TEXT, ONBOARDING_LOADING_STATES, ONBOARDING_ROUTES, ONBOARDING_STATES_MESSAGE_MAP, PHONE_NUMBER_TEXT } from '../constants';
import TextInput from '../../../components/input/textinput/TextInput';
import { useDispatch, useSelector } from 'react-redux';
import {componentKey as onboardingComponentKey, setNavigateNextFromCompanyInfo, setOnboardingData, setSelectedCountry} from '../OnboardingSlice';
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown';
import { Controller, useForm } from 'react-hook-form';
import { saveOnboardingData } from '../OnboardingSaga';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { countryCodes } from '../../../components/countrycodes/countrycodesdata';
import Loadable from '../../../components/loadable/Loadable';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import General from '../../../../libs/utility/General';

export default function GetCompanyInfo() {

    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const { register, control, handleSubmit, watch, formState: {errors}, reset } = useForm();
    const { loadingState, onboardingData, navigateNextFromCompanyInfo, selectedCountry } = useSelector((state) => state[onboardingComponentKey]);

    useEffect(() => {
        if(navigateNextFromCompanyInfo){
            navigate(`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.COMPANY_SIZE}`);
            dispatch(setNavigateNextFromCompanyInfo(true));
        }
    }, [navigateNextFromCompanyInfo]);

    const handleInputChange = (e, onChangeValidationController, fieldType) => {
        
        const { name, value } = e.target;
        onChangeValidationController(value);
        const formFields = {
            ...onboardingData,
            [name]: value,
        }
        dispatch(setOnboardingData(formFields));
    };
    const phoneNumberRegex = /^\d{10}$/;


    const validateData = (e, onChange) => {
        General.validateInputWithRegex(e, () => handleInputChange(e, onChange))
    }

    const handleCountryCodeDropDownChange = (name, selectedOption) => {
        const formFields = { 
            ...onboardingData, 
            CountryCode: selectedOption.value,
        }
        dispatch(setOnboardingData(formFields));
        dispatch(setSelectedCountry(selectedOption));
    }

    const handleFormSubmit = () => {
        if(!onboardingData.CompanyName || !onboardingData.PhoneNumber){
            dispatch(addNotifications({ heading: "Company information required", message: "To continue, please input your company details" }))
        }else{
            dispatch(saveOnboardingData({onboardingDataToSave: onboardingData, goToNextScreenCb: setNavigateNextFromCompanyInfo, nextScreenStateValue: true}));
        }
    }

    return (
        <>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[ONBOARDING_LOADING_STATES.SAVE_ONBOARDING_ACTION_LOADING]}
                messageMap={ONBOARDING_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
            <div style={commonStyles.onboardingStepContainer}>
                <div style={commonStyles.formDiv}>
                    <div style={styles.stepImageDiv}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.GET_COMPANY_STEP_ICON} />
                    </div>
                    <div style={styles.stepTitleContainer}>
                        <Heading type={HEADING.H1}>Tell us about your company</Heading>
                        <div>
                            <p style={styles.stepTitleDesc}>
                                We will need your company name & phone number
                            </p>
                        </div>
                    </div>
                    <div style={styles.companyDetailsFormContainer}>
                        <div style={styles.fieldDiv}>
                            <div><label style={styles.fieldLabel}>Company name</label></div>
                            <div>
                                <Controller
                                    control={control}
                                    name="CompanyName"
                                    defaultValue={onboardingData.CompanyName}
                                    rules={{ 
                                        required: "Company name cannot be empty",
                                    }}
                                    render={({ field : {value, onChange} }) => (
                                        <TextInput 
                                            type={'text'}
                                            placeHolder={'Company name'}
                                            name={'CompanyName'} 
                                            value={value} 
                                            onChangeCb={(e) => validateData(e, onChange)} 
                                        />
                                    )}
                                />
                                {errors.CompanyName && <span style={styles.errorMessage}>{errors.CompanyName.message}</span>}
                            </div>
                        </div>
                        <div style={{...styles.fieldDiv, ...styles.phoneFieldDiv}}>
                            <div><label style={styles.fieldLabel}>Phone number</label></div>
                            <div style={styles.phoneNumberRow}>
                                <div style={styles.phoneDivWError}>
                                    <SelectDropdown
                                        name="CountryCode"
                                        value={{ label: selectedCountry.label, value: selectedCountry.value }}
                                        prefixProps={{ text: selectedCountry.value }}
                                        onSelectCb={(name, selectedOption) => handleCountryCodeDropDownChange(name, selectedOption)}
                                        options={countryCodes}
                                    />
                                    <div style={styles.phoneNumberErrorDiv}></div>
                                </div>
                                <div style={styles.phoneDivWError}>
                                    <Controller
                                        control={control}
                                        name="PhoneNumber"
                                        defaultValue={onboardingData.PhoneNumber}
                                        rules={{ 
                                            required: "Phone number cannot be empty",
                                            pattern: {
                                                value: phoneNumberRegex,
                                                message: 'Invalid phone number format'
                                            },
                                        }}
                                        render={({ field : {value, onChange} }) => (
                                            <TextInput 
                                                type={'text'}
                                                placeHolder={'Phone number'}
                                                name={'PhoneNumber'} 
                                                value={value} 
                                                onChangeCb={(e) => validateData(e, onChange)} 
                                            />
                                        )}
                                    />
                                    <div style={styles.phoneNumberErrorDiv}>{errors.PhoneNumber && <span style={styles.errorMessage}>{errors.PhoneNumber.message}</span>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterWImageAndActionButtons
                    nextButton={{
                        text: "Next",
                        clickCb: handleSubmit(handleFormSubmit),
                    }}
                >
                    <span>Welcome to our group of 100,000+ trusted businessess! <br />#1 IRS eFile platform for information reporting</span>
                </FooterWImageAndActionButtons>
            </div>
            </Loadable>
        </>
    )
}